module.exports = __webpack_public_path__ + "img/prizeRanking2.5cfe95bb.png";